<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <v-card>
      <v-card-title>
        行動要素編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text>
        <v-form ref="act_emt_form">
          <v-container>
            <v-row>
              <v-col cols="6">
                <FormInputComponent
                  label="表示順"
                  type="number"
                  v-model="showOrder"
                  rules="required"
                />
              </v-col>

              <v-col cols="12">
                <FormInputComponent
                  label="行動要素名"
                  type="string"
                  v-model="actEmtName"
                  rules="required"
                  :counter="30"
                />
              </v-col>

              <v-col cols="12">
                <v-select
                  label="使用状態"
                  v-model="expiration"
                  item-text="label"
                  item-value="value"
                  :items="isActiveLabels"
                  return-object
                  outlined
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
              <v-col v-if="!entryFlg">
                <Button @click="delete_confirm" color="danger">削除</Button>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <ConfirmDialog
          ref="confirm"
          title="行動要素編集"
          :message="confirmMessage"
          buttonMessage="OK"
          @confirm="editActEmtInfo"
        >
        </ConfirmDialog>
        <DialogMessage ref="dialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem } from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    dialog: false,
    confirm: false,
    entryFlg: false,
    confirmMessage: null,
    deleteFlg: false,
    resolve: null,
    reject: null,

    actEmtId: null,
    organaizationKey: null,
    actEmtName: null,
    showOrder: 0,
    createdAt: null,
    updateAt: null,

    expiration: { label: '', value: '' },

    isActiveLabels: [
      { label: config.USE_IN_NAME, value: config.USE_IN },
      { label: config.USE_STOP_NAME, value: config.USE_STOP },
    ],
  }),

  methods: {
    open(item) {
      this.dialog = true;
      // セレクトボックス初期化
      this.expiration = { label: '', value: '' };

      // 行動要素設定
      if (item == null) {
        this.entryFlg = true;
        this.actEmtId = null;
        this.organaizationKey = null;
        this.actEmtName = null;
        this.showOrder = null;
        this.expiration = { label: '', value: '' };
        this.createdAt = null;
        this.updateAt = null;
      } else {
        this.entryFlg = false;
        this.actEmtId = item.ACT_EMT_ID;
        this.organaizationKey = item.ORGANIZATION_KEY;
        this.actEmtName = item.ACT_EMT_NAME;
        this.expiration.value = item.EXPIRATION;
        this.showOrder = item.SHOW_ORDER;
        this.createdAt = item.CREATED_AT;
        this.updateAt = item.UPDATED_AT;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.act_emt_form.validate()) {
        return;
      }
      // 使用状態チェック
      if (this.expiration.value == null || !this.expiration.value) {
        this.$refs.dialog.open(
          'info',
          '使用状態が選択されていません。使用状態を選択して下さい。'
        );
        return;
      }

      // 確認ダイアログ表示
      this.deleteFlg = false;
      this.confirmMessage =
        '[' + this.actEmtName + ']の行動要素を登録しますか？';
      this.$refs.confirm.open();
    },
    delete_confirm() {
      // 入力チェック
      if (!this.$refs.act_emt_form.validate()) {
        // チェックエラー
        return;
      }

      // 確認ダイアログ表示
      this.deleteFlg = true;
      this.confirmMessage =
        '[' + this.actEmtName + ']の行動要素を削除しますか？';
      this.$refs.confirm.open();
    },
    editActEmtInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.deleteFlg) {
        // 削除処理
        this.deleteActEmtInfoRequest();
      } else {
        // 登録処理
        this.editActEmtInfoRequest();
      }
    },
    editActEmtInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // ユーザ情報作成
      if (this.entryFlg) {
        // 新規登録
        this.actEmtId =
          userInfo.ORGANIZATION_KEY + moment().format('YYYYMMDDHHmmss');
        this.createdAt = moment().format('YYYYMMDDHHmmss');
      }

      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 行動要素情報登録リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/manages/action/entry',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            ACT_EMT_ID: this.actEmtId,
            ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
            ACT_EMT_NAME: this.actEmtName,
            SHOW_ORDER: this.showOrder,
            EXPIRATION: this.expiration.value,
            CREATED_AT: this.createdAt,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_ACTEMT_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    deleteActEmtInfoRequest() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // 新規登録モードの場合は処理終了
      if (this.entryFlg) {
        return;
      }

      //----- 行動要素情報削除リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/manages/action/delete',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,
            ACT_EMT_ID: this.actEmtId,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = this.actEmtName + message.MSG_INFO_ACTEMT_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.dialog = false;
    },
  },
};
</script>
